import { Injectable } from '@angular/core';
import { CommonService } from '../../../shared/utils/common.service';
import { UtilsService } from '../../../shared/utils/utils.service';
import { Observable } from 'rxjs';
import { PlmDiccionario, plmModulo } from '../diccionarios/plm-diccionario';

@Injectable({
    providedIn: 'root'
  })

export class plmService {

  urlPLM_RDL  : string;
  diccionarioUrl: any;

  constructor(private commom: CommonService, private utilServices: UtilsService) {
    this.urlPLM_RDL     = this.utilServices.getUrlPlm();
    //this.urlPLM_RDL   = "http://localhost:8080/plm-api/v1/api/service/";
    this.diccionarioUrl = plmModulo.url;
  }

  getAllClasesInpeccion(){
    let url = this.urlPLM_RDL + this.diccionarioUrl.crudClaseInspeccion+"all";
    return this.commom.peticionGetConHeader(url);
  }

  createQmMatriz(payload: any){
    let url = this.urlPLM_RDL + this.diccionarioUrl.crudClaseInspeccion+"crear";
    return this.commom.peticionPostConHeader(url, payload);
  }

  getAllClasesInpeccionHistoria(){
    let url = this.urlPLM_RDL + this.diccionarioUrl.logMatrizQm;
    return this.commom.peticionGetConHeader(url);
  }

  updateQmMatriz(payload: any){
    let url = this.urlPLM_RDL + this.diccionarioUrl.crudClaseInspeccion+"actualizar";
    return this.commom.peticionPutConHeader(url, payload);
  }

  preUploadCSV(payload: any){
    let url = this.urlPLM_RDL + this.diccionarioUrl.matrizPreCargarCSV;
    return this.commom.peticionPostConHeader(url, payload);
  }

  saveUploadCSV(payload: any){
    let url = this.urlPLM_RDL + this.diccionarioUrl.matrizGuardarCSV;
    return this.commom.peticionPostConHeader(url, payload);
  }

  deleteQmMatriz(payload: any){
    let url = this.urlPLM_RDL + this.diccionarioUrl.crudClaseInspeccion+"eliminar";
    return this.commom.peticionDeleteConHeader(url, payload);
  }

}
